import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Interface User adaptée à la vraie structure de DB
interface User {
  id: string // VARCHAR dans la vraie DB
  username: string // username au lieu d'email
  profile_picture?: string // Photo de profil optionnelle
  is_admin: boolean // Boolean is_admin au lieu du système de rôles
  created_at: string
  updated_at: string
}

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  setAuth: (user: User, token: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      setAuth: (user, token) => 
        set({ user, token, isAuthenticated: true }),
      logout: () => 
        set({ user: null, token: null, isAuthenticated: false }),
    }),
    {
      name: 'auth-storage',
    }
  )
) 